<template>
  <base-material-card
    inline
    :icon="icon"
    :title="title"
    class="px-5 py-3"
    :color="color"
    :small-icon="smallIcon"
  >
    <div v-if="!isLoading">
      <!-- Affichage du message d'erreur -->
      <card-alert
        v-if="hasError"
        :msg="errorMsg"
      />

      <!-- Affichage du message si aucune donnée -->
      <card-alert
        v-else-if="isEmpty"
        :msg="errorEmpty.msg"
        :icon="errorEmpty.icon"
        :color="errorEmpty.color"
      />
      <!-- Affichage du tableau -->
      <v-simple-table v-else>
        <thead>
          <tr>
            <th
              v-for="(header, h_index) in headers"
              :key="h_index"
              :class="color + '--text'"
            >
              {{ header }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(data, d_index) in datas"
            :key="d_index"
          >
            <td
              v-for="(field, f_index) in data"
              :key="f_index"
            >
              {{ field }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div v-else>
      <!-- Affichage du chargement -->
      <v-row justify="center">
        <circle10 />
      </v-row>
    </div>
  </base-material-card>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import CardAlert from '../../alerts/CardAlert.vue'
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'RegularTablesTemplate',

    /* Sous-composants utilisés par ce composant */
    components: {
      CardAlert,
      Circle10,
    },

    /* Paramètres */
    props: {
      headers: {
        type: Array,
        default: undefined,
      },
      datas: {
        type: Array,
        default: undefined,
      },
      title: {
        type: String,
        default: undefined,
      },
      isLoading: {
        type: Boolean,
        default: true,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: '',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
      icon: {
        type: String,
        default: 'mdi-clipboard-text',
      },
      smallIcon: {
        type: Boolean,
        default: false,
      },
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      isEmpty: function () {
        return this.datas.length === 0
      },
    },
  }
</script>
